import React from 'react';
import { engagementModels } from '../../data/mock';

const EngagementSection = () => {
  return (
    <section id="engagement" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#0D2438]"></div>
      
      {/* Subtle background image - Network connections */}
      <div className="absolute inset-0 opacity-[0.04]">
        <img 
          src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2944&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Dots pattern */}
      <div className="absolute inset-0 opacity-[0.05]" style={{
        backgroundImage: `radial-gradient(rgba(91, 181, 197, 0.8) 1px, transparent 1px)`,
        backgroundSize: '30px 30px'
      }}></div>

      {/* Decorative glows */}
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[#1F7A8C]/10 rounded-full blur-[150px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">Engagement Models</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-4 max-w-2xl">
          How We Engage
        </h2>
        <p className="text-[#B8C8D8] text-lg mb-12 max-w-3xl">
          <span className="text-[#E8B86D]">IJSS IT Solutions</span> offers flexible engagement models designed to complement 
          existing partner ecosystems and enterprise requirements while reducing delivery risk.
        </p>

        {/* Engagement Models */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {engagementModels.map((model, index) => (
            <div key={model.id} className="service-card h-full flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 rounded-full bg-gradient-to-r from-[#1F7A8C] to-[#2A9AAD] text-[#0B1F33] font-semibold text-sm flex items-center justify-center">
                  {index + 1}
                </span>
              </div>
              <h3 className="text-[#5BB5C5] font-semibold text-lg mb-4">
                {model.title}
              </h3>
              <p className="text-[#A8B8C8] mb-6 flex-grow">
                {model.description}
              </p>
              <div className="pt-4 border-t border-[rgba(91,181,197,0.15)]">
                <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-wider mb-3">
                  Key Benefits
                </p>
                <ul className="space-y-2">
                  {model.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 bg-[#5BB5C5] rounded-full mt-2 flex-shrink-0"></span>
                      <span className="text-[#8899AA] text-sm">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Risk Reduction Statement */}
        <div className="bg-gradient-to-r from-[rgba(91,181,197,0.1)] to-[rgba(91,181,197,0.05)] border border-[rgba(91,181,197,0.2)] p-6 rounded-lg">
          <p className="text-[#A8B8C8]">
            These engagement models reduce project risk by providing access to 
            dedicated <span className="text-[#5BB5C5]">MDG expertise</span> while maintaining clear accountability. 
            System integrators, advisory firms, and enterprises benefit from 
            specialized delivery without resource diversion.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EngagementSection;
